import script from "./orderStock.vue?vue&type=script&setup=true&lang=ts"
export * from "./orderStock.vue?vue&type=script&setup=true&lang=ts"

import "./orderStock.vue?vue&type=style&index=0&id=ac792ede&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac792ede"]])

export default __exports__